import { type PassengerCount, type PassengerFare } from '../types';
import PriceClass from '../PriceClass';
import type VerifyResult from '@itinerary/VerifyResult';
import { type InvoiceEntry } from '@store/invoice';
import { PaxType } from '@utils/types';
import type { SegmentOption } from '@itinerary/trip/types';

export default abstract class TripPriceClass extends PriceClass {
    priceDescription: string | null = null;

    abstract get showCapacity(): boolean;

    abstract get capacityText(): string;

    abstract get passengerFares(): PassengerFare[];

    capacityTextReplacement: string | null = null;

    get priceOptions(): SegmentOption[] {
        return [];
    }

    /**
     * Verifies the ability to reserve, and creates a new bill, and new reservation
     */
    abstract verify(
        count: PassengerCount,
        billId: number | null
    ): Promise<VerifyResult>;

    /**
     * Loads the fares of different types of passengers of the trip
     */
    abstract loadPreInvoice(count: {
        adultCount: number;
        childCount: number;
        infantCount: number;
    }): Promise<InvoiceEntry[]>;

    get adultFare(): PassengerFare | undefined {
        return this.passengerFares.find(f => f.paxType === PaxType.Adult);
    }

    get childFare(): PassengerFare | undefined {
        return this.passengerFares.find(f => f.paxType === PaxType.Child);
    }

    get infantFare(): PassengerFare | undefined {
        return this.passengerFares.find(f => f.paxType === PaxType.Infant);
    }
}
